module.exports = __webpack_public_path__ + "static/img/pic63.aeb3d72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic63.png
// module id = l2Y8
// module chunks = 1